import { useAuthStore } from '@/store/useAuthStore';
import { Modal, ModalContent } from '@nextui-org/react';
import { Button } from './Button';

export const LogoutWarningModal = () => {
  const show = useAuthStore(state => state.showLogoutWarning);
  const logout = useAuthStore(state => state.logout);
  const dismissLogoutWarning = useAuthStore(state => state.dismissLogoutWarning);

  if (!show) return null;

  const handleLogout = () => {
    dismissLogoutWarning();
    logout();
  };

  return (
    <Modal
      backdrop="blur"
      isOpen={true}
      size={'xl'}
      hideCloseButton={true}
      classNames={{
        wrapper: 'custom-modal'
      }}
    >
      <ModalContent>
        <div className="p-6 w-full flex flex-col items-center gap-6">
          <p className="text-xl leading-8 pb-2">Your access expired, please signin again</p>
          <Button label="Login" onClick={handleLogout} className="w-48" />
        </div>
      </ModalContent>
    </Modal>
  );
};
